import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import InvoiceDetailContainer from 'components/plansales/invoice/invoiceDetail/InvoiceDetailContainer';

const InvoiceDetail = (routeInfo: RouteComponentProps<{ invoiceNo: string }>) => {
  const { invoiceNo } = routeInfo.match.params;
  return <InvoiceDetailContainer invoiceNo={invoiceNo} />;
};

export default InvoiceDetail;
